<script>
export default {
  props: ['value', 'disabled', 'placeholder'],
  data() {
    return {
      $value: `${this.value}`,
    };
  },
  watch: {
    value() {
      const valueToString = Array.isArray(this.value) ? this.value.join(', ') : this.value;
      this.$data.$value = `${this.value ? valueToString : ''}`;
      this.$refs.input.value = this.$data.$value;
    },
  },
  methods: {
    update() {
      this.$emit('update:value', this.$data.$value);
    },
    clear() {
      this.$data.$value = '';
      this.$emit('update:value', this.$data.$value);
    },
  },
};
</script>

<template lang="pug">
span(:class="$style.root")
  input(
    type="text",
    ref="input",
    @input="update()",
    @change="update()",
    :class="$style.input",
    :placeholder="placeholder",
    :disabled="disabled",
    v-model.trim="$data.$value")
  span(:class="$style.border")
</template>

<style module lang="sass">
.root
  display: block
  width: 100%
  padding-bottom: 12px
  position: relative

.input
  display: block
  padding: 0
  border: 0
  box-sizing: border-box
  outline: none
  color: $color_text
  font-size: FS_INPUT
  height: 16px
  max-height: 160px
  line-height: 16px
  font-weight: 500
  background-color: transparent
  caret-color: $color_main
  width: 100%
  resize: none
  overflow-x: hidden
  &:hover + .border
    background-color: $color_main
    height: 2px

  &:focus + .border
    background-color: $color_main
    height: 2px

  &:disabled
    cursor: not-allowed
    & + .border
      background-color: transparent
      height: 1px
      border-bottom: 1px dotted $color_text_second

.border
  display: block
  position: absolute
  left: 0
  right: 0
  bottom: 0
  height: 2px
  background-color: $color_divider
  transition: background-color $a_speed, height $a_speed

</style>
